import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { handleStateChange } from 'functions/actions'

class InlineEditableString extends Component {
  constructor(props){
    super(props)

    const { editing, value } = this.props

    this.state = {
      editing,
      value: value || '',
    }
  }

  static getDerivedStateFromProps(props){
    const { editing, value } = props

    return {
      editing,
      value,
    }
  }

  _toggleEdit = () => {
    const { editing } = this.state
    this.setState({
      editing: !editing,
    })
  }

  _save = () => {
    const { value } = this.state
    const { fieldName, saveCallback } = this.props
    if (saveCallback) saveCallback(fieldName, value)
    this._cancelEdit()
  }

  render(){
    const { editing, value } = this.state
    const { render, renderEdit } = this.props

    if (editing){
      return renderEdit({
        value,
        onChange: e => handleStateChange(this, 'value', e),
        save: this._save,
        cancel: this._toggleEdit,
      })
    }

    return render({
      value,
      toggleEdit: this._toggleEdit,
    })
  }
}

InlineEditableString.propTypes = {
  editing: PropTypes.bool,
  fieldName: PropTypes.string,
  render: PropTypes.func.isRequired,
  renderEdit: PropTypes.func.isRequired,
  saveCallback: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object, PropTypes.bool]),
}

InlineEditableString.defaultProps = {
  editing: false,
  value: '',
}

export default InlineEditableString
